// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-users-modal[data-v-52d3fd34]{overflow-y:auto}.delete-users-modal .delete-users-modal__title[data-v-52d3fd34]{line-height:36px!important;margin-top:-14px}.delete-users-modal__select_item[data-v-52d3fd34]{max-width:100%}@media(min-width:768px){.delete-users-modal__select_item[data-v-52d3fd34]{max-width:430px}}[data-v-52d3fd34] .v-list-item{max-height:100px!important;min-height:65px!important}", ""]);
// Exports
module.exports = exports;
